import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHTituloGet = async (credentials, data) => {
    const body = {
        service: "RNHTituloGet",
        params: {
            rnhTituloId: data?.id || null,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
